import React, { useState } from "react";
import CreateCrdential from "./CreateCredential/CreateCredential";
import AddAgent from "./AddAgent/AddAgent";
import CreateuserLogin from "./Createuserlogincredential/CreateuserLogin";
import { useSelector } from "react-redux";

const AgentDetails = () => {
  const [activeComponent, setActiveComponent] = useState("agentDetails");
  const { profileData } = useSelector((state) => {
    return {
      profileData: state?.authReducer?.profileData,
    };
  });
  const userPermissions = profileData?.permissions || [];
  const userRole = profileData?.role || "";

  return (
    <div>
      {/* Navigation buttons */}
      <div style={{ marginBottom: "20px", display: "flex", gap: "3px" }}>
        <h6
          onClick={() => setActiveComponent("agentDetails")}
          style={{
            padding: "8px 16px",
            fontSize: "20px",
            fontWeight: "normal",
            color: activeComponent === "agentDetails" ? "blue" : "black",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Agent Details
        </h6>
        <h6
          onClick={() => setActiveComponent("createCredential")}
          style={{
            padding: "8px 16px",
            fontSize: "20px",
            fontWeight: "normal",
            color: activeComponent === "createCredential" ? "blue" : "black",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Create Credential
        </h6>
        <h6
          onClick={() => setActiveComponent("loginCredential")}
          style={{
            padding: "8px 16px",
            fontSize: "20px",
            fontWeight: "normal",
            color: activeComponent === "loginCredential" ? "blue" : "black",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          AI Credential
        </h6>
      </div>

      {/* Conditional rendering of components */}
      {activeComponent === "agentDetails" && (
        <AddAgent permissions={userPermissions} role={userRole} />
      )}
      {activeComponent === "createCredential" && (
        <CreateCrdential permissions={userPermissions} role={userRole} />
      )}
      {activeComponent === "loginCredential" && (
        <CreateuserLogin permissions={userPermissions} role={userRole} />
      )}
    </div>
  );
};

export default AgentDetails;
